import { makeStyles, Tooltip as MuiTooltip } from '@material-ui/core';
import { mergeClasses } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React from 'react';

function marginGenerator() {
  return {
    '&$tooltipPlacementLeft': {
      marginRight: 12,
    },
    '&$tooltipPlacementRight': {
      marginLeft: 12,
    },
    '&$tooltipPlacementTop': {
      marginBottom: 12,
    },
    '&$tooltipPlacementBottom': {
      marginTop: 12,
    },
  };
}

const useStyles = makeStyles((theme) => ({
  popper: {
    opacity: 0.88,
  },
  popperInteractive: {},
  popperArrow: {},
  tooltip: {
    ...theme.typography.body2,
    maxWidth: 240,
    padding: '8px 12px',
    color: theme.colors.white,
    backgroundColor: theme.colors.dark,
    borderRadius: theme.borderRadius.small,
    boxShadow: theme.shadow.componentDark,
  },
  tooltipArrow: {
    ...marginGenerator(),
  },
  arrow: {
    fontSize: 12,
  },
  touch: {},
  tooltipPlacementLeft: {
    margin: '0 4px 0 0',
  },
  tooltipPlacementRight: {
    margin: '0 0 0 4px',
  },
  tooltipPlacementTop: {
    margin: '0 0 4px',
  },
  tooltipPlacementBottom: {
    margin: '4px 0 0',
  },
}));

const Tooltip = React.forwardRef((props, ref) => (
  <MuiTooltip
    ref={ref}
    {...props}
    classes={mergeClasses({ baseClasses: useStyles(), newClasses: props.classes })}
  />
));

Tooltip.propTypes = {
  classes: PropTypes.object,
};

Tooltip.defaultProps = {
  classes: {},
};

export default Tooltip;
